// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#seguir{
    align-self: flex-end;
    margin-right: 16%;
    margin-bottom: 2%;
}
.custom-link {
    text-decoration: none;  
    color: inherit;         
    font-weight: bold;      
    cursor: pointer;  
    color: #223263;       
  }
  
  .custom-link:hover {
    color: #636363;           
  }
`, "",{"version":3,"sources":["webpack://./src/styles/HomeButton.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB","sourcesContent":["#seguir{\n    align-self: flex-end;\n    margin-right: 16%;\n    margin-bottom: 2%;\n}\n.custom-link {\n    text-decoration: none;  \n    color: inherit;         \n    font-weight: bold;      \n    cursor: pointer;  \n    color: #223263;       \n  }\n  \n  .custom-link:hover {\n    color: #636363;           \n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
